<template>
<div>
    <v-toolbar color="primary" class="white--text" mb-2 flat>
        <h2 class="title">Roster</h2>
        <v-spacer></v-spacer>
        <!-- need to get print function working -->
        <!-- <v-btn color="white">
        <v-icon large>print</v-icon>
      </v-btn> -->
    </v-toolbar>
    <v-card>
        <v-card-text>
            <h4>Enrolled ({{ course.current_seats }}/{{ course.max_seats }})</h4>
            <v-data-table :headers="headers" :items="course.enrolled" hide-actions class="mb-3">
                <template slot="items" slot-scope="props">
                    <tr>
                        <td>{{ props.item.first_name }}</td>
                        <td>{{ props.item.last_name }}</td>
                        <td>{{ props.item.grade }}</td>
                        <td class="text-xs-center">{{ props.item.pivot.updated_at }}</td>
                        <td class="text-xs-center">
                            <v-btn class="red white--text" small @click="initActionDialog('drop_class', props.item)">Drop</v-btn>
                        </td>
                    </tr>
                </template>
            </v-data-table>

            <h4>Waitlist ({{ course.wait_list }}/5)</h4>
            <v-data-table :headers="headers" :items="course.waiting" hide-actions class="mb-3">
                <template slot="items" slot-scope="props">
                    <tr>
                        <td>{{ props.item.first_name }}</td>
                        <td>{{ props.item.last_name }}</td>
                        <td>{{ props.item.grade }}</td>
                        <td class="text-xs-center">{{ props.item.pivot.updated_at }}</td>
                        <td class="text-xs-center">
                            <v-btn class="green white--text" small @click="initActionDialog('add_class', props.item)">Add to class</v-btn>
                            <v-btn class="red white--text" small @click="initActionDialog('drop_waitlist', props.item)">Remove from waitlist</v-btn>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card-text>

    </v-card>

    <v-dialog v-model="actionDialog.active" persistent max-width="500px">
        <v-card>
            <v-card-title>
                <p class="headline">{{ actionDialog.message }}</p>
            </v-card-title>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red lighten-4" @click="actionDialog.active = false">No</v-btn>
                <v-btn color="green lighten-4" @click="executeAction">Yes</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog persistent v-model="classStatusAlert" max-width="500px">
        <v-card>
            <v-card-text>
                <v-alert class="title" :value="true" type="error">{{ httpResponseMessage }}</v-alert>
            </v-card-text>
            <v-card-actions>
                <v-btn color="primary" flat @click.stop="classStatusAlert = false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
import jsPDF from 'jspdf'
import 'jspdf-autotable'

export default {
    data() {
        return {
            headers: [{
                    text: 'First Name',
                    sortable: false,
                    align: 'left',
                    value: 'first_name',
                    width: '20%'
                },
                {
                    text: 'Last Name',
                    sortable: false,
                    align: 'left',
                    value: 'last_name',
                    width: '20%'
                },
                {
                    text: 'Grade',
                    sortable: false,
                    align: 'left',
                    value: 'grade',
                    width: '5%'
                },
                {
                    text: 'Timestamp',
                    sortable: false,
                    align: 'center',
                    value: 'pivot.updated_at',
                    width: '20%'
                },
                {
                    text: 'Actions',
                    sortable: false,
                    align: 'center',
                    value: '',
                    width: '35%'
                }
            ],
            selectedStudent: {},
            actionDialog: {
                active: false,
                message: '',
                action: ''
            },
            classStatusAlert: false
        }
    },
    computed: {
        course() {
            return this.$store.state.courseModule.courseInfo
        },
        culprit() {
            return this.$store.getters.culprit
        },
        httpResponseMessage() {
            return this.$store.state.enrollment.httpResponse.message
        }
    },
    methods: {
        initActionDialog(action, student) {
            this.selectedStudent = student
            this.actionDialog.active = true
            switch (action) {
                case 'drop_class':
                    this.actionDialog.action = 'drop_class'
                    this.actionDialog.message = `Drop ${student.first_name} ${student.last_name} from ${this.course.name}?`
                    break
                case 'add_class':
                    this.actionDialog.action = 'add_class'
                    this.actionDialog.message = `Enroll ${student.first_name} ${student.last_name} in ${this.course.name}?`
                    break
                case 'drop_waitlist':
                    this.actionDialog.action = 'drop_waitlist'
                    this.actionDialog.message = `Remove ${student.first_name} ${student.last_name} from ${this.course.name} waitlist?`
                    break
            }
        },
        executeAction() {
            let payload = {
                schedule_id: this.selectedStudent.pivot.id, // can eventually get rid of this
                course_id: this.selectedStudent.pivot.course_id,
                student_id: this.selectedStudent.pivot.student_id,
                culprit: this.culprit
            }
            switch (this.actionDialog.action) {
                case 'drop_class':
                    this.$store.dispatch('adminDropFromClass', payload)
                        .then(() => this.actionDialog.active = false)
                        .catch(() => {
                            this.actionDialog.active = false
                            this.classStatusAlert = true
                        })
                    break
                case 'add_class':
                    this.$store.dispatch('adminMoveFromWaitlistToClass', payload)
                        .then(() => this.actionDialog.active = false)
                        .catch(() => {
                            this.actionDialog.active = false
                            this.classStatusAlert = true
                        })
                    break
                case 'drop_waitlist':
                    this.$store.dispatch('adminDropFromWaitlist', payload)
                        .then(() => this.actionDialog.active = false)
                        .catch(() => {
                            this.actionDialog.active = false
                            this.classStatusAlert = true
                        })
                    break
            }
        },
        // printRoster () {
        //   let doc = new jsPDF();

        //   let title = this.course.section + ' | ' + this.course.name + ' | ' + this.course.teacher.first_name + ' ' + this.course.teacher.last_name +
        //               ' | ' + this.course.semester

        //   let columns = [
        //     { title: 'First Name', dataKey: 'first_name'},
        //     { title: 'Last Name', dataKey: 'last_name'},
        //     { title: 'Grade', dataKey: 'grade'},
        //   ]

        //   let rows = []
        //   this.course.students.forEach((s) => {
        //     rows.push({ first_name: s.first_name, last_name: s.last_name, grade: s.grade })
        //   })

        //   doc.setFontSize(12)
        //   doc.text(title, 12, 25);
        //   doc.autoTable(columns, rows, { startY: 30, theme: 'striped' })
        //   doc.save(this.course.name + '-roster.pdf');
        // }
    }
}
</script>
